export const GET_DASHBOARD_ANALYTICS = "GET_DASHBOARD_ANALYTICS";
export const GET_DASHBOARD_ANALYTICS_SUCCESS = "GET_DASHBOARD_ANALYTICS_SUCCESS";

export const API_ERROR = "API_ERROR";